import { useMemo } from 'react';

interface ImageItem {
    src: string;
    alt: string;
    name: string;
}

interface PlantingImageGalleryProps {
    isOpen: boolean;
    type: 'plme' | 'plds';
}

const PlantingImageGallery = ({ isOpen, type }: PlantingImageGalleryProps) => {
    const images = useMemo<ImageItem[]>(() => {
        if (type === 'plme') {
            return [
                {
                    src: '/images/planting/plme/b.png',
                    alt: '고랑파종',
                    name: '고랑파종(B)',
                },
                {
                    src: '/images/planting/plme/s.png',
                    alt: '건조종자직파',
                    name: '건조종자직파(S)',
                },
                {
                    src: '/images/planting/plme/c.png',
                    alt: '삽목',
                    name: '삽목(C)',
                },
                {
                    src: '/images/planting/plme/h.png',
                    alt: '수평삽목',
                    name: '수평삽목(H)',
                },
                {
                    src: '/images/planting/plme/i.png',
                    alt: '경사삽목',
                    name: '경사삽목(I)',
                },
                {
                    src: '/images/planting/plme/n.png',
                    alt: '육묘이식',
                    name: '육묘이식(N)',
                },
                {
                    src: '/images/planting/plme/p.png',
                    alt: '발아종자파종',
                    name: '발아종자파종(P)',
                },
                {
                    src: '/images/planting/plme/r.png',
                    alt: '재생재배',
                    name: '재생재배(R)',
                },
                {
                    src: '/images/planting/plme/t.png',
                    alt: '이식재배',
                    name: '이식재배(T)',
                },
                {
                    src: '/images/planting/plme/v.png',
                    alt: '수직삽목',
                    name: '수직삽목(V)',
                },
            ];
        } else {
            return [
                {
                    src: '/images/planting/plds/r.png',
                    alt: '조파',
                    name: '조파(R)',
                },
                {
                    src: '/images/planting/plds/b.png',
                    alt: '산파',
                    name: '산파(U)',
                },
                {
                    src: '/images/planting/plds/h.png',
                    alt: '점파',
                    name: '점파(H)',
                },
            ];
        }
    }, [type]);

    return (
        <div className={`planting-gallery-accordion ${isOpen ? 'open' : ''}`}>
            <div className="row mb-3">
                <div className="col-md-2"></div>
                <div className="col-md-10">
                    <div className="planting-img-container">
                        {images.map((image, index) => (
                            <div key={index} className="planting-item">
                                <div className="planting-preview">
                                    <img
                                        src={image.src}
                                        className="planting-img"
                                        alt={image.alt}
                                    />
                                    <span className="planting-name">
                                        {image.name}
                                    </span>
                                </div>
                                <div className="planting-overlay">
                                    <img
                                        src={image.src}
                                        className="planting-img-large"
                                        alt={image.alt}
                                    />
                                    <span className="planting-name-large">
                                        {image.name}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlantingImageGallery;
